import { HttpClient } from '../api/httpclient.service';

export interface MissionItem {
    id: string | number;
    type: 'lesson' | 'exercise';
    full_topic_label?: string;
    percentage: number;
    completed_count: number;
    total_count: number;
    status: number;
    level_name?: string;
    
    // Payload fields for navigation
    lesson_id?: number;
    topic_id?: number;
    level_id?: number;
    sub_topic_id?: number;
    last_interaction_id?: string;
    exercise_id?: number;
}

export interface MissionsResponse {
    open_missions: MissionItem[];
    completed_missions: MissionItem[];
}

export class MissionsService extends HttpClient {
    constructor() {
        super();
    }

    public async getAllMissions(): Promise<MissionsResponse> {
        try {
            return await this.get<MissionsResponse>('/missions/all');
        } catch (error) {
            console.error('Error fetching all missions:', error);
            throw error;
        }
    }
}
